import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { nanoid } from 'nanoid' // Usaremos nanoid para generar IDs únicos.

interface AlertState {
    id: string // Añadimos un identificador único.
    severity: 'success' | 'error' | 'warning'
    message: string
}

const initialState: AlertState[] = []

const alertSlice = createSlice({
    name: 'alerts',
    initialState,
    reducers: {
        showAlert: (state, action: PayloadAction<Omit<AlertState, 'id'>>) => {
            state.push({ ...action.payload, id: nanoid() }) // Generamos un id único.
        },
        removeAlert: (state, action: PayloadAction<string>) => {
            return state.filter(alert => alert.id !== action.payload) // Removemos alerta por id.
        },
        clearAlerts: (state) => {
            return []
        }
    }
})

export const { showAlert, removeAlert, clearAlerts } = alertSlice.actions
export default alertSlice.reducer
